<div class="show-data-input">
  <label class="show-data-input__label">{{ label }}</label>
  <p class="show-data-input__data {{ class }} m-0" [class.mt-1]="label">
    <span>
      <ng-content></ng-content>
    </span>
    <mat-icon
      *ngIf="suffix"
      class="show-data-input__data_suffix"
      [class.size-13px]="iconSize === 'small'"
      [class.size-16px]="iconSize === 'normal'"
    >
      {{ suffix }}
    </mat-icon>
  </p>
</div>
